import React, { useEffect, useState } from "react";
import {
    Box,
    Typography,
} from "@mui/material";
import {
    CUSTOMERS
} from "../../redux/apis";
import { MyProfile as MyProfileData } from "../../classes/MyProfile";
import { axiosAuthInstance } from "../../redux/axiosInstance";

const HEIGHT = window.innerHeight;

type Props = {
};

const MyProfile: React.FC<Props> = ({
}) => {
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [myProfileData, setMyProfleData] = useState<MyProfileData>();
    useEffect(() => {
        const token = localStorage.getItem("token");
        const customerId = localStorage.getItem("customerId");
        const firstName = localStorage.getItem("firstName");

        if (token && customerId && firstName) {
            setIsLoggedIn(true);
            getMyProfile();
        } else {
            setIsLoggedIn(false);
        }
    }, []);

    const getMyProfile = async () => {
        try {
            const response: any = await axiosAuthInstance.get(`${CUSTOMERS}/me`);
            if (response) {
                try {
                    setMyProfleData(response.data);
                } catch (error) {
                    console.error("Invalid JSON:", error);
                }
            } else {
                console.warn("Empty response");
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };


    return (
        <>
            <Box p={3} mx="auto" style={{ marginTop: (HEIGHT * 4) / 100, borderRadius: 14, backgroundColor: '#f8f3f3', border: '1px solid #7a7272' }}>
                <Typography
                    variant="body1"
                    style={{ marginBottom: (HEIGHT * 2) / 100 }}
                >
                    <b> Name:</b>    {myProfileData?.firstName} {myProfileData?.lastName}
                </Typography>
                <Typography
                    variant="body1"
                    style={{ marginBottom: (HEIGHT * 2) / 100 }}
                >
                    <b> Email:</b> {myProfileData?.email}
                </Typography>
                <Typography
                    variant="body1"
                    style={{ marginBottom: (HEIGHT * 2) / 100 }}
                >
                    <b> Mobile Number: </b>{myProfileData?.mobileNumber}
                </Typography>
                <Typography
                    variant="body1"
                    style={{ marginBottom: (HEIGHT * 2) / 100 }}
                >
                    <b>  Member since: </b>{myProfileData?.createdAt.toLocaleString().split('T')[0]}
                </Typography>

            </Box>
        </>
    );
};

export default MyProfile;
